import { Effect } from "../Materials/effect";
import "./ShadersInclude/kernelBlurVaryingDeclaration";
import "./ShadersInclude/kernelBlurVertex";
var name = 'kernelBlurVertexShader';
var shader = "\nattribute vec2 position;\n\nuniform vec2 delta;\n\nvarying vec2 sampleCenter;\n#include<kernelBlurVaryingDeclaration>[0..varyingCount]\nconst vec2 madd=vec2(0.5,0.5);\nvoid main(void) {\nsampleCenter=(position*madd+madd);\n#include<kernelBlurVertex>[0..varyingCount]\ngl_Position=vec4(position,0.0,1.0);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var kernelBlurVertexShader = { name: name, shader: shader };
//# sourceMappingURL=kernelBlur.vertex.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Shaders/kernelBlur.vertex.js
// module id = null
// module chunks = 